export type Menu = 'BASIC' | 'ADVANCED' | 'PERMISSIONS';
export const SIDE_MENU: Record<Menu, string> = {
  BASIC: 'Basic',
  ADVANCED: 'Advanced',
  PERMISSIONS: 'Permissions',
};

export interface ArticleFormValues {
  description: string;
  contributors: any; // FIXME: waiting backend to update API with user avatar
  categories: string[];
  tags: { label: string; value: string }[];
  copyright: string;
  disabledComment: boolean;
}

export enum CreateAs {
  SETTINGS = 'SETTINGS',
  DRAFT = 'DRAFT',
  PUBLISH = 'PUBLISH',
}
